function toggleSidecart(event){
  event.preventDefault();
  $('body').toggleClass("drawer--sidecart");
}

$('#cart_icon').click(function(event) {
  toggleSidecart(event);  
});

$('#header_sidecart .drawer_close').click(function(event) {
  event.preventDefault();
  event.stopPropagation(); // Prevents the event from reaching $(document).on("click")
  toggleSidecart(event);
});



$(document).ready(function() {
  window.addEventListener('scroll', function(){
    if (window.pageYOffset > 50) $('body').addClass("has_scrolled");
    else $('body').removeClass("has_scrolled");
  });
});

$(document).on("click", function(event){
  // If clicking the drawer_close button, close the sidecart and stop further execution
  if ($(event.target).closest(".drawer_close").length) {
    toggleSidecart(event);
    return; // Stop further execution to prevent conflicts
  }

  // Close the sidecart if clicking outside it
  if( $('body').hasClass("drawer--sidecart") && 
      !$(event.target).closest("#header_sidecart").length && 
      !$(event.target).closest("#cart_icon").length) {
    toggleSidecart(event);
  }
  
  // Close the menu if clicking outside it
  if( $('body').hasClass("menu_active") && 
      !$(event.target).closest("#mob_menu").length && 
      !$(event.target).closest("#nav_page").length && 
      !$(event.target).closest("#menu_button").length) {
    $('body').removeClass("menu_active");
  }
});


// Search Function

$('#menu_search, #header_search').click(function() {
  if ( $('body').hasClass("search_active") ) { console.log("Search active already");}
  else {
    $('body').addClass("search_active");
    $('#menusearch_form_wrap').addClass("active");
    $('#menusearch_input').focus();
  }
});

$('#searchpage_close').click(function() {
  $('body').removeClass("search_active");
  $('#menusearch_form_wrap').removeClass("active");
});

// Dropdown functions

$( document ).ready(function() {
  $('.drop_item').click(function(){
    var wrapper = $(this).parent().parent();
    if ( $(wrapper).hasClass("active") ) {
      if ( $(this).hasClass("active") == false ) {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
      }
      $(wrapper).removeClass("active");
    }
    else $(wrapper).addClass("active");
  });
});


$( document ).ready(function() {
  $('#giftcard_options .drop_item').click(function(){
    var data_option = $(this).data('option');
    $('#giftcard_option').attr("value", data_option);
  });
  $('#giftcard_amount .drop_item').click(function(){
    var var_id = $(this).data('var_id');
    $('#giftcard_var').attr("value", var_id);
    // Additional styling to fix overlap issue
    $('#giftcard_options').toggleClass('inactive');
  });
});
